import React, { useState } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { FolderKanban, Users, TrendingUp, Clock, HandCoins, WalletCards } from 'lucide-react';
import './index.css';
import PendingInvoicesPopup from '../PendingInvoicePopup';
import SlidingModal from '../../SlidingModal/slidingModal';
import { formatINR } from '../../../util/indianCurrency';
const RevenueSummary = ({ totalRevenue, totalProjects, totalUsers, receivedRevenue, pendingRevenue, selectedProject, differenceRevenue, pendingRevenueInvoicesData }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
    <div className="revenue-summary">
      <Row className="g-3">
        <Col>
          <Card className="summary-card">
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div>
                <p className="summary-label">Total Revenue</p>
                <h3 className="summary-value" style={{color : "#2563EB"}}>{formatINR(totalRevenue)}</h3>
              </div>
              <div className="summary-icon-wrapper revenue">
                <HandCoins style={{color : "#2563EB"}} className="summary-icon" />
              </div>
            </Card.Body>
          </Card>
        </Col>
        {!selectedProject && (
        <Col>
          <Card className="summary-card projects">
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div>
                <p className="summary-label">Total Projects</p>
                <h3 className="summary-value" style={{color : "#059669"}}>{totalProjects}</h3>
              </div>
              <div className="summary-icon-wrapper projects">
                <FolderKanban style={{color : "#059669"}} className="summary-icon" />
              </div>
            </Card.Body>
          </Card>
        </Col>
        )}
        <Col>
          <Card className="summary-card users">
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div>
                <p className="summary-label">Total Employees</p>
                <h3 className="summary-value" style={{color : "#e21b6e"}}>{totalUsers}</h3>
              </div>
              <div className="summary-icon-wrapper users">
                <Users className="summary-icon" style={{color : "#e21b6e"}} />
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="summary-card received">
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div>
                <p className="summary-label">Received Revenue</p>
                <h3 className="summary-value" style={{color : "#7c3aed"}}>{formatINR(receivedRevenue)}</h3>
              </div>
              <div className="summary-icon-wrapper received">
                <TrendingUp style={{color : "#7c3aed"}} className="summary-icon" />
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col onClick={() => setShowModal(true)} style={{ cursor: 'pointer' }}>
          <Card className="summary-card pending">
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div>
                <p className="summary-label">Pending Revenue</p>
                <h3 className="summary-value" style={{color : "#d97706"}}>{formatINR(pendingRevenue)}</h3>
              </div>
              <div className="summary-icon-wrapper pending">
                <Clock style={{color : "#d97706"}} className="summary-icon" />
              </div>
            </Card.Body>
          </Card>
        </Col>
         <Col>
          <Card className="summary-card difference"  title="Difference Revenue = Total Revenue - Received Revenue">
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div>
                <p className="summary-label">Difference Revenue</p>
                <h3 className="summary-value" style={{color : "#cb06d9"}}>{formatINR(differenceRevenue)}</h3>
              </div>
              <div className="summary-icon-wrapper difference">
                <WalletCards style={{color : "#cb06d9"}} className="summary-icon" />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
   <SlidingModal
      modalName="Pending Revenue Invoices"
      isModalOpen={showModal}
      closeBtn={() => setShowModal(false)}
    >
      <PendingInvoicesPopup data={pendingRevenueInvoicesData} />
    </SlidingModal>
    </>
    
    
  );
};

export default RevenueSummary;